module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lMu8Q"))).then(() => module.bundle.root('fThBo'));